import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { useTranslation } from "@common/hooks/translation";

import ClientTransactionClient from "../components/client";
import ClientTransactionAdminConfirm from "../components/adminConfirm";
import { startCollectDepositMoney } from "@app/dev/helpers/clientTransaction";
import Timer from "@common/components/timer";
import Config from "@app/dev/config/main";
import MoneyAmount from "@common/components/moneyAmount";
import { getAuthData } from "@common/helpers/auth";

const DepositStart = ({ client, onBack, onNext, maxDepositAmount }) => {
  const t = useTranslation();
  const [amount, setAmount] = useState(0);
  const [timer, setTimer] = useState(60);

  const isAdminLoggedIn = useSelector((state) => state.terminal.isAdminLoggedIn);

  const [isAdminConfirmed, setIsAdminConfirmed] = useState(
    Boolean(isAdminLoggedIn) || Config.enableClientTransactionWithoutAdmin
  );

  const handleBack = () => {
    onBack?.();
  };

  useEffect(() => {
    if (isAdminLoggedIn) setIsAdminConfirmed(true);
  }, [isAdminLoggedIn]);

  useEffect(() => {
    if (isAdminConfirmed) {
      const finish = startCollectDepositMoney((amount) => {
        setAmount(amount);
        setTimer(60);
      });

      return finish;
    }
  }, [isAdminConfirmed]);

  const currencyConfig = { name: getAuthData()?.currency, rate: 1, rounding: 2 };

  const taxAmount = (amount * client.DepositTaxPercentage) / 100;
  const depositAmountWithoutTax = amount - taxAmount;

  return (
    <div className="ct-form">
      <h3 className="ct-form-title">{t("Deposit")}</h3>
      {isAdminConfirmed && (
        <p className="ct-form-subtitle">{t("Insert the appropriate amount into the terminal to make a deposit")}</p>
      )}
      {/* <ClientTransactionClient data={{ firstName: 'Eduard', lastName: 'Voskanyan', id: '123456789' }} /> */}

      {!!amount && <Timer duration={60} onChange={setTimer} value={timer} onFinish={onNext} />}

      <ClientTransactionClient data={client} />

      {isAdminConfirmed && (
        <>
          <div className="ct-deposit-amount-wrap">
            <i className="global-icon icon-terminal-deposit-success" />
            {t("Deposit Amount")}
            <span>{amount}</span>
          </div>
          <div className="ct-info-container">
            {!!taxAmount && (
              <div className="ct-info-row">
                <span>
                  {t("Deposit tax")}: ({client.DepositTaxPercentage}%)
                </span>
                <span>
                  <MoneyAmount config={Config} amount={taxAmount} currencyConfig={currencyConfig} />
                </span>
              </div>
            )}
            {!!taxAmount && (
              <div className="ct-info-row">
                <span>{t("Total deposit amount")}</span>
                <span>
                  <MoneyAmount config={Config} amount={depositAmountWithoutTax} currencyConfig={currencyConfig} />
                </span>
              </div>
            )}
            <div className="ct-info-row">
              <span>{t("Max deposit amount")}</span>
              <span>
                <MoneyAmount config={Config} amount={maxDepositAmount} currencyConfig={currencyConfig} />
              </span>
            </div>
          </div>
        </>
      )}

      {!isAdminConfirmed && <ClientTransactionAdminConfirm />}

      <div className="ct-form-buttons">
        {amount ? (
          <button className="ct-form-submit-btn" onClick={onNext}>
            {t("Deposit")}
          </button>
        ) : (
          <button onClick={handleBack}>{t("Back")}</button>
        )}
      </div>
    </div>
  );
};

DepositStart.propTypes = {
  client: PropTypes.object.isRequired,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  maxDepositAmount: PropTypes.number,
};

export default DepositStart;
